import { render, staticRenderFns } from "./OnairDescriptionEditor.vue?vue&type=template&id=a5e0f886&"
import script from "./OnairDescriptionEditor.vue?vue&type=script&lang=js&"
export * from "./OnairDescriptionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnairDescriptionEditor.vue"
export default component.exports